var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCommentaryTab(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.2324 9.82476V2.19727C13.2324 0.985645 14.2181 0 15.4297 0H21.2891C22.5007 0 23.4863 0.985645 23.4863 2.19727V5.12695C23.4863 6.33857 22.5007 7.32422 21.2891 7.32422H15.733L13.2324 9.82476Z",
    fill: "#FABE2C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M18.3594 7.32422H21.2891C22.5007 7.32422 23.4863 6.33857 23.4863 5.12695V2.19727C23.4863 0.985645 22.5007 0 21.2891 0H18.3594V7.32422Z",
    fill: "#FF9100"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M4.44336 12.4512H11.7676V10.2539L10.3027 9.52148L11.7676 8.78906V8.05664C11.7676 6.03516 10.127 4.39453 8.10547 4.39453C6.08398 4.39453 4.44336 6.03516 4.44336 8.05664V8.78906L5.9082 9.52148L4.44336 10.2539V12.4512Z",
    fill: "#E6F7FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M4.44336 12.4512V13.916C4.44336 15.9375 6.08398 17.5781 8.10547 17.5781C10.127 17.5781 11.7676 15.9375 11.7676 13.916V12.4512H4.44336Z",
    fill: "#47568C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M11.7676 13.916V12.4512H8.10547V17.5781C10.127 17.5781 11.7676 15.9375 11.7676 13.916Z",
    fill: "#29376D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M11.7676 12.4512V10.2539L10.3027 9.52148L11.7676 8.78906V8.05664C11.7676 6.03516 10.127 4.39453 8.10547 4.39453V12.4512H11.7676ZM8.83789 23.5352V19.7754H7.37305V23.5352H4.44336V25H11.7676V23.5352H8.83789Z",
    fill: "#CCEEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M16.1621 2.92969H17.627V4.39453H16.1621V2.92969Z",
    fill: "#47568C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M19.0918 2.92969H20.5566V4.39453H19.0918V2.92969ZM8.83789 8.78906H11.7676V10.2539H8.83789V8.78906Z",
    fill: "#29376D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M4.44336 8.78906H7.37305V10.2539H4.44336V8.78906Z",
    fill: "#47568C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M8.10547 19.7754V25H11.7676V23.5352H8.83789V19.7754H8.10547Z",
    fill: "#B3D9FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M13.2324 10.2539V11.7188H2.97852V10.2539H1.51367V13.916C1.51367 17.5509 4.47056 20.5078 8.10547 20.5078C11.7404 20.5078 14.6973 17.5509 14.6973 13.916V10.2539H13.2324ZM8.10547 19.043C5.27876 19.043 2.97852 16.7427 2.97852 13.916V13.1836H13.2324V13.916C13.2324 16.7427 10.9322 19.043 8.10547 19.043Z",
    fill: "#CCEEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M14.6973 13.916V10.2539H13.2324V11.7188H8.10547V13.1836H13.2324V13.916C13.2324 16.7427 10.9322 19.043 8.10547 19.043V20.5078C11.7404 20.5078 14.6973 17.5509 14.6973 13.916Z",
    fill: "#B3D9FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommentaryTab);
export default __webpack_public_path__ + "static/media/commentaryTab.357216bdfc64661b043405ed724d7aa8.svg";
export { ForwardRef as ReactComponent };